import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Paper } from '@mui/material';
import { BarChart as AnalyticsIcon } from '@mui/icons-material';

const Analytics = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <AnalyticsIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            {t('pages.analytics')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('pages.underConstruction')}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default Analytics;
